import styled from 'styled-components'
import { LookButton, iconButtonLook } from 'components/Buttons/look'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`

export const TextContainer = styled.div`
  flex: 1;
  p { line-height: 16px; }
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: left;
  margin-bottom: 0px;
`

export const Label = styled(InfoText)`
  color: #777777;
`

export const MoneyTextMask = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 16px;
  font-weight: bold;
  line-height: 14px;
  margin-bottom: 0px;
  padding: 0px;
`

export const SmallButton = styled(LookButton).attrs(iconButtonLook())`
  margin: 0px;
`
